import { render, staticRenderFns } from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=template&id=441751aa&scoped=true&"
import script from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialContaminantsPesticides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441751aa",
  null
  
)

export default component.exports